// extracted by mini-css-extract-plugin
export default {"userselect_input":"PermissionUserSelect_userselect_input__ClIPP","userselect_dropdown":"PermissionUserSelect_userselect_dropdown__yH3GK"};